import _classCallCheck from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Parameters } from "./parameters";
/**
 * Name Address SIP header.
 * @public
 */
export var NameAddrHeader = /*#__PURE__*/function (_Parameters) {
  _inherits(NameAddrHeader, _Parameters);
  var _super = _createSuper(NameAddrHeader);
  /**
   * Constructor
   * @param uri -
   * @param displayName -
   * @param parameters -
   */
  function NameAddrHeader(uri, displayName, parameters) {
    var _this;
    _classCallCheck(this, NameAddrHeader);
    _this = _super.call(this, parameters);
    _this.uri = uri;
    _this._displayName = displayName;
    return _this;
  }
  _createClass(NameAddrHeader, [{
    key: "friendlyName",
    get: function get() {
      return this.displayName || this.uri.aor;
    }
  }, {
    key: "displayName",
    get: function get() {
      return this._displayName;
    },
    set: function set(value) {
      this._displayName = value;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new NameAddrHeader(this.uri.clone(), this._displayName, JSON.parse(JSON.stringify(this.parameters)));
    }
  }, {
    key: "toString",
    value: function toString() {
      var body = this.displayName || this.displayName === "0" ? '"' + this.displayName + '" ' : "";
      body += "<" + this.uri.toString() + ">";
      for (var parameter in this.parameters) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.parameters.hasOwnProperty(parameter)) {
          body += ";" + parameter;
          if (this.parameters[parameter] !== null) {
            body += "=" + this.parameters[parameter];
          }
        }
      }
      return body;
    }
  }]);
  return NameAddrHeader;
}(Parameters);